import { InvoiceItemUnit } from "src/app/backend/models/invoice/invoice.item";

export enum GoodType {
  DRUG = "drug",
  PRODUCT = "product"
}

export enum GoodUnit {
  PIECE = "piece",
  PACKAGE = "package"
}

export type GoodStock = {
  storageId: string;
  batchNumber?: string;
  quantity?: number;
  expiresAt?: string;
  price?: number;
};

export interface Good {
  id: string;
  name: string;
  gtin?: string; // aic o ean
  minsan?: string;
  type: GoodType;

  unit: GoodUnit;
  quantity: number;

  stocks?: Array<GoodStock>;

  storageId: string;
  storageQuantities?: Record<string, number>;

  createdAt: string;
  deletedAt?: string;

  reorderPoint: number | null;

  version: number;

  pieces: number;
  price?: number;
  priceChange?: number;

  sendings: any;
}

export type GoodUpdate = Pick<
  Good,
  "version" | "pieces" | "reorderPoint" | "price" | "name"
>;

export type GoodLight = Pick<
  Good,
  | "id"
  | "name"
  | "stocks"
  | "minsan"
  | "gtin"
  | "type"
  | "quantity"
  | "unit"
  | "pieces"
  | "version"
  | "storageQuantities"
>;

export function goodUnitFromInvoiceItemUnit(
  unit: InvoiceItemUnit | undefined
): GoodUnit | undefined {
  switch (unit) {
    case InvoiceItemUnit.PIECE:
      return GoodUnit.PIECE;
    case InvoiceItemUnit.PACKAGE:
      return GoodUnit.PACKAGE;
    case undefined:
      return undefined;
  }
}
